<template>
  <div class="content main-container">
    <div class="approveBtn">
      <span class="label">当前审批模式</span>
      <RadioGroup v-model="approve" @on-change="changeMode">
        <Radio label="1">自动审批</Radio>
        <Radio label="2">人工审批</Radio>
      </RadioGroup>
    </div>
    <Tabs v-model="tabValue" class="tab" @on-click="changeData()">
      <TabPane label="待审批" name="1"></TabPane>
      <TabPane label="已审批" name="2"></TabPane>
    </Tabs>
    <div class="search-box">
      <div class="input-item">
        <span class="label">审批ID</span>
        <Input v-model="searchParams.id" placeholder="请输入" clearable />
      </div>
      <div class="input-item">
        <span class="label">发起时间</span>
        <DatePicker transfer v-model="timeArray" format="yyyy-MM-dd" type="daterange" placeholder="请选择"
          @on-change="changeTime"></DatePicker>
      </div>
      <div class="input-item">
        <span class="label">发起人所属机构</span>
        <selectTree v-model="searchParams.organId" type="4" ref="selectTreeRef"></selectTree>
      </div>
      <div class="input-item">
        <span class="label">发起人</span>
        <Select v-model="searchParams.salesmanId" filterable transfer clearable>
            <Option v-for="(item, i) in userList" :key="i" :value="item.id">
              <i class="dian" :class="{'red': item.workingState == 0 ,'orange':item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </Select>
        <!-- <Select clearable v-model="searchParams.salesmanId" style="width:256px;" filterable :transfer="true">
          <Option :value="item.id" v-for="(item, index) in salesmanList" :key="index"
            :label="item.staffNo + (item.staffNo ? '/' : '') + item.name"></Option>
        </Select> -->
      </div>
      <div class="input-item">
        <span class="label">审批项名称</span>
        <Input v-model="searchParams.name" placeholder="请输入" clearable />
      </div>
      <div class="input-item" v-if="tabValue == '2'">
        <span class="label">审批状态</span>
        <RadioGroup v-model="searchParams.status">
          <Radio label="">全部</Radio>
          <Radio label="1">已通过</Radio>
          <Radio label="-1">已退回</Radio>
        </RadioGroup>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">搜索</Button>
        <Button type="primary" ghost @click="resetData()">重置</Button>
      </div>
    </div>
    <div class="tableBox">
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="mode">
          <lzDicTxt dicType="CHECK_MODE" :dicCode="row.mode"></lzDicTxt>
        </template>
        <template slot-scope="{ row }" slot="status">
          <lzDicTxt dicType="CHECK_STATUS" :dicCode="row.status"></lzDicTxt>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div class="detail">
            <div>
              <span @click="openDetail(row)">详情</span>
            </div>
          </div>
        </template>
      </Table>
    </div>
    <div class="pageBox">
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageChange"
        style="text-align: center" />
    </div>
    <bannerModal ref="bannerModal" @refresh="getList"></bannerModal>
  </div>
</template>

<script>
import { common } from "@/api/mixins";
import { pageTool } from "@/api/mixins";
import selectTree from '@/components/system/selectTree3';
import bannerModal from "./components/bannerModal"
import lzDicSelect from "@/components/commons/lzDicSelect";
import lzDicTxt from "@/components/commons/lzDicTxt";
export default {
  mixins: [common, pageTool],
  components: { selectTree, bannerModal, lzDicSelect, lzDicTxt },
  data() {
    return {
      pageSize: 10,
      total: 0,
      approve: '1',
      tabValue: '1',
      salesmanList: [], // 业务员
      timeArray: [], // 发起时间
      userList:[],//业务员列表
      searchParams: {},
      columns: [
        {
          title: "审批ID",
          key: "id",
          minWidth: 200,
          align: "center"
        },
        {
          title: "发起时间",
          key: "createTime",
          minWidth: 180,
          align: "center"
        },
        {
          title: "发起人",
          key: "salesmanName",
          minWidth: 120,
          align: "center"
        },
        {
          title: "发起人所属机构",
          key: "organName",
          minWidth: 120,
          align: "center"
        },
        {
          title: "审批类型",
          key: "type",
          minWidth: 140,
          align: "center",
          render(h, item) {
            return (
              <span>微店编辑审批</span>
            );
          }
        },
        {
          title: "审批项名称",
          key: "name",
          minWidth: 120,
          align: "center"
        },
        {
          title: "审批模式",
          slot: "mode",
          minWidth: 120,
          align: "center"
        },
        {
          title: "审批状态",
          slot: "status",
          minWidth: 120,
          align: "center"
        },
        {
          title: "操作 ",
          slot: "action",
          minWidth: 100,
          align: "center",
          fixed:'right'
        }
      ],
    }
  },
  activated(){
    this.getUserList();
    this.getTabData()
    this.getMode()
    this.getList()
  },
  created() {
    // this.getOrganizationUser(null)
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.initListAjax("/buz/check/queryCheckVersion")
    this.$nextTick(() => {
      this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange();
    });
  },
  methods: {
    setReqParams(params){
        params.apiPermissionCode = 'operate_6_0';
    },
    changeData() {
      this.getTabData()
      this.searchAjax()
    },
    resetData() {
      this.timeArray = [];
      this.resetSearch();
      this.getMode();
      this.getTabData();
    },
    // 修改审批模式
    changeMode(item) {
      this.$http({
        url: `/buz/check/updateCheckConfig`,
        type: "POST",
        data: {
          mode: item
        }
      }).then((res) => {
        this.$notice.success('更改成功');
      })
    },
    getTabData() {
      if (this.tabValue == '1') {
        this.searchParams.statusIn = [0]
      } else {
        this.searchParams.statusIn = [1, -1]
      }
    },
    // 获取审核模式
    getMode() {
      this.$http({
        url: `/buz/check/queryCheckConfig`,
        type: "GET",
        data: {}
      }).then((res) => {
        this.approve = String(res.data.mode)
      })
    },
    changeTime(time) {
      this.searchParams.createTimeStart = time[0];
      this.searchParams.createTimeEnd = time[1];
    },
    // 设置请求方式
    setRequstType() {
      return 'PUT'
    },
    // 打开详情弹窗
    openDetail(val) {
      this.$refs.bannerModal.open(val)
    },
    // 分页
    pageChange(pageNo) {
      this.pageNum = pageNo;
      this.getList()
    },
    // 获取当前机构业务员
    getUserList() {
      this.$http({
        url: '/buz/userBase/getSubUser',
        type: 'get',
        data: {
          orgId: this.userInfo.organId,
        },
      }).then((res) => {
        this.userList = res.data;
      })
    },
    // 通过机构获取业务员
    getOrganizationUser(id) {
      this.$http({
        url: `/buz/userBase/getByOrgIds`,
        type: "POST",
        data: {
          orgaList: id ? [id] : []
        }
      }).then((res) => {
        this.salesmanList = res.data;
      })
    },
    // 机构树选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {
        //机构
        this.searchParams.policyOrgId = data.id;
        this.searchParams.groupId = "";
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.policyOrgId = "";
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.policyOrgId = "";
        this.searchParams.groupId = "";
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>